import { CSSProperties, ReactNode } from 'react'
import { StrictInputProps } from 'semantic-ui-react'
import { Form } from '@/ui'
import ErrorLabel from './ErrorLabel'

interface FieldInputProps extends Omit<StrictInputProps, 'error'> {
  input: any
  width?: number
  style?: CSSProperties
  label?: ReactNode
  touched?: boolean
  error?: string
  labelText?: string | null
  defaultRating?: number
}

// TODO: Find better way to handle semantic ui width classes
const widthClass = (width?: number) => {
  switch (width) {
    case 1:
      return ' one wide'
    case 2:
      return ' two wide'
    case 3:
      return ' three wide'
    case 4:
      return ' four wide'
    case 5:
      return ' five wide'
    case 6:
      return ' six wide'
    case 7:
      return ' seven wide'
    case 8:
      return ' eight wide'
    case 9:
      return ' nine wide'
    case 10:
      return ' ten wide'
    case 11:
      return ' eleven wide'
    case 12:
      return ' twelve wide'
    case 13:
      return ' thirteen wide'
    case 14:
      return ' fourteen wide'
    case 15:
      return ' fifteen wide'
    case 16:
      return ' sixteen wide'
    default:
      return ''
  }
}

const FieldInput = ({
  width,
  style,
  label,
  input,
  touched,
  error,
  labelText,
  defaultRating,
  ...rest
}: FieldInputProps) => (
  <Form.Field className={widthClass(width)} style={style}>
    {label}

    <Form.Input
      {...input}
      {...rest}
      onChange={(...args) => {
        input.onChange(...args)
        if (rest.onChange) {
          rest.onChange(...args)
        }
      }}
      error={!!(touched && error)}
    />
    {touched && error && error.length && <ErrorLabel error={error} />}
  </Form.Field>
)

export default FieldInput
